import script from "./ordersInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ordersInfo.vue?vue&type=script&setup=true&lang=js"

import "./ordersInfo.vue?vue&type=style&index=0&id=657a9755&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-657a9755"]])

export default __exports__